/**
 * StatusIndicator.js — Animated Connected / Disconnected badge
 */

import React from "react";

export default function StatusIndicator({ connected }) {
  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold
                  border transition-all duration-500 ${
                    connected
                      ? "bg-emerald-50 border-emerald-200 text-emerald-700"
                      : "bg-red-50 border-red-200 text-red-600"
                  }`}
    >
      {/* Animated dot */}
      <span className="relative flex h-2 w-2">
        {connected && (
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full
                           bg-emerald-400 opacity-75" />
        )}
        <span
          className={`relative inline-flex rounded-full h-2 w-2 ${
            connected ? "bg-emerald-500" : "bg-red-500"
          }`}
        />
      </span>
      {connected ? "Connected" : "Disconnected"}
    </div>
  );
}
